<template>
    <div>
        <h3 class="text-xl font-semibold text-gray-900">
            {{ title }}
        </h3>

        <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-5">
            <licenses-overview-item
                :count="license.unregisteredQuantity"
                :future-licenses="license.quantity - license.unregisteredQuantity - license.registeredQuantity"
                :type="license.name"
                :key="license.name"
                v-for="license in filteredLicenses"
            />
            <li v-if="filteredLicenses.length === 0">
                {{ $t('dashboard.noAvailableType') }}
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import LicensesOverviewItem from './LicensesOverviewItem.vue';

    export default {
        components: { LicensesOverviewItem },

        props: {
            title: {
                type: String,
                required: true,
            },
            licenseData: {
                type: Array,
                required: true,
            },
        },

        computed: {
            ...mapState([
                'licenseTypes',
                'authUserLicenseTypes',
            ]),
            filteredLicenses() {
                const validLicenses = [];
                for (let i = 0; i < this.licenseData.length; i++) {
                    const license = this.licenseData[i];
                    if (license.quantity !== 0 || license.unregisteredQuantity !== 0) validLicenses.push(license);
                    else {
                        for (let j = 0; j < this.authUserLicenseTypes.length; j++) {
                            if (license.id === this.authUserLicenseTypes[j].id) validLicenses.push(license);
                        }
                    }
                }
                return validLicenses;
            },
        },

        methods: {
            findLicenseType(id) {
                return this.licenseTypes.find(license => license.id === id);
            },
        },
    };
</script>
